export default "/images/claritick-img.svg?b37bfa01def2bd9f8b03beac1eba9f3a";